import React from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import LoadingBar from '../../../components/global/loadingBar';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/cross.svg';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class ShowFileModal extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			fileNumber: 1,
			isLoading: true,
		};
	}
	componentDidMount = () => {
		if (this.props.file.fileType !== 'pdf') this.setState({ isLoading: false });
	};
	render() {
		return (
			<div className="file-uploaded-display-modal">
				<div className="create-main-container">
					<div className="project-title-container">
						<div className="left-title-box">
							<div className="left-title-item">
								<div className="title">{this.props.file.originalFileName}</div>
							</div>
						</div>
						<div className="notes-icon" onClick={() => this.props.handleClose()}>
							<CloseIcon />
						</div>
					</div>
					<div
						className={
							this.state.isLoading
								? 'create-project-body-container pdf-loading'
								: 'create-project-body-container'
						}
					>
						{this.props.file.fileType === 'pdf' ? (
							<Document
								file={this.props.fileSrc}
								error=""
								loading={
									<div className="loading-indicator-fg">
										<LoadingBar />
									</div>
								}
								onLoadSuccess={() => this.setState({ isLoading: false })}
							>
								<Page pageNumber={this.state.fileNumber} width="500" />
							</Document>
						) : this.props.file.fileType === 'jpeg' ||
						  this.props.file.fileType === 'png' ? (
							<img src={this.props.fileSrc + `&randomJibberish=${123456789}`} />
						) : null}
					</div>
				</div>
			</div>
		);
	}
}

export default ShowFileModal;
